<template>
  <div id="app" class="relative bg">
    <router-view></router-view>
    <v-msg ref="msg"></v-msg>
    <v-loading :show-tag="showLoading"></v-loading>
  </div>
</template>
<script>
  import VMsg from '../src/components/common/v-msg'
  import VLoading from '../src/components/common/v-loading'

  export default {
    name: 'App',
    data() {
      return {
        loadingQueue: [],
        showLoading: false
      }
    },
    components: {VLoading, VMsg},
    created() {
      bus.$on('msg', (msg) => {
        this.$refs.msg.show(msg)
      })
      bus.$on('loading', (data) => {
        if (data === false) {
          let index = this.loadingQueue.findIndex(r => r.status === true)
          let item = this.loadingQueue[index] || {}
          item.status = false
          this.loadingQueue.splice(index, 1, item)
          if (this.loadingQueue.every(r => r.status === false)) {
            this.showLoading = false
            this.loadingQueue = []
          }
        } else {
          this.showLoading = true
          this.loadingQueue.push({
            t: new Date().toLocaleString(),
            status: true
          })
        }
      })
    },
    watch: {
      showLoading(newV) {
        bus.$emit('showLoading', newV)
      }
    }
  }
</script>

<style lang="scss">
  @import "../src/style/base";
  @import "../src/style/program";
  @import "../src/style/mixin";

  #app, .page {
    height: calc(100vh);
  }

  .line2 {
    @include lines(2);
  }

  .bus_card{
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.04);
    border-radius: 8px;
    background-color: #FFFFFF;
  }

  .dash{
    border-bottom: 1px dashed #E7E7E7;
  }
</style>



// WEBPACK FOOTER //
// h5/App.vue